import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService, ResponseObject } from 'src/app/Services/auth.service';
import { Consignment, ConsignmentService, FetchConsignmentsRequestParam } from 'src/app/Services/consignment.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';

/**
 * Artist "Dispatch" page (Phase-2 nav, Messages section).
 *
 * Lists consignments a gallery has accepted but the artist hasn't dispatched yet,
 * with a one-click "Mark as dispatched" action.
 */
@Component({
    selector: 'app-dispatch',
    templateUrl: './dispatch.component.html',
    styleUrls: ['./dispatch.component.css'],
    standalone: false
})
export class DispatchComponent implements OnInit {
    public consignments: Consignment[] = [];
    public loaded = false;
    private artistId = '';

    constructor(
        private auth: AuthService,
        private consignmentService: ConsignmentService,
        private notifications: NotificationsService,
        private spinner: NgxSpinnerService
    ) { }

    public ngOnInit(): void {
        this.artistId = this.auth.getUserId();
        this.load();
    }

    private load(): void {
        this.spinner.show();
        const req: FetchConsignmentsRequestParam = { ArtistId: this.artistId };
        this.consignmentService.getConsignments(req).subscribe({
            next: (rows) => {
                // Accepted by the gallery, not yet dispatched by the artist.
                this.consignments = (rows || []).filter(c => c.IsAccepted && !c.IsDispatched);
                this.loaded = true;
                this.spinner.hide();
            },
            error: () => { this.loaded = true; this.spinner.hide(); }
        });
    }

    public consignmentLabel(c: Consignment): string {
        return c.Title || c.Name || 'Consignment';
    }

    public dispatch(c: Consignment): void {
        this.spinner.show();
        this.consignmentService.dispatchConsignment(c.Guid).subscribe({
            next: (res: ResponseObject) => {
                this.spinner.hide();
                if (res?.Success) {
                    this.notifications.showNotification('Dispatched', `Marked "${this.consignmentLabel(c)}" as dispatched.`, NotificationTypes.Success);
                    this.consignments = this.consignments.filter(x => x !== c);
                } else {
                    this.notifications.showNotification('Could not dispatch', res?.ResponseMessage || 'Please try again.', NotificationTypes.Error);
                }
            },
            error: () => { this.spinner.hide(); this.notifications.showNotification('Could not dispatch', 'Please try again.', NotificationTypes.Error); }
        });
    }
}
